import { Route, Switch, useRouteMatch } from "react-router-dom";
import { SHOW_NEW_PP_PLAN_PAGE_FEATURE_FLAG } from "../../context/features/features.utils";
import { useExperiment } from "../../hooks/useExperiment";
import AccountLanding from "./AccountLanding/AccountLanding";
import { usePermissions } from "../../hooks/usePermissions";
import { ADMIN } from "../../types/roles";

const AccountRouter = () => {
  const { useExperimentValue } = useExperiment();
  const isNewAccountPageEnabled = useExperimentValue(
    SHOW_NEW_PP_PLAN_PAGE_FEATURE_FLAG,
    true,
  ) as boolean;

  const { path } = useRouteMatch("/account");

  const { hasAtLeastRole } = usePermissions();

  if (!hasAtLeastRole(ADMIN)) {
    return window.location.replace("/main");
  }

  if (!isNewAccountPageEnabled) {
    return window.location.replace("/settings/account");
  }

  return (
    <Switch>
      {/* Keep `exact` here, as the legacy logout route is `/account/logout` and this will otherwise match that route, preventing logout */}
      <Route exact path={path} component={AccountLanding} />
    </Switch>
  );
};

export default AccountRouter;
